export default function HotelViewMapController(
    $scope,
    $stateParams,
    mapsFactory,
    hotelDetails
) {
    'ngInject';

    const vm = this;
    const HOTEL_DETAILS_ZOOM = 18;
    const hotelMarker = createMarker(0, hotelDetails.Hotel);

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        mapsFactory.initialize($scope);
        assignVarsToScope();
    }

    function assignVarsToScope() {
        $scope.showMap = true;
        $scope.MarkersWithLabel = [hotelMarker];
        $scope.map.zoom = HOTEL_DETAILS_ZOOM;
        $scope.map.center = {
            latitude: hotelMarker.latitude,
            longitude: hotelMarker.longitude,
        };
    }

    function createMarker(index, hotel) {
        const labelTemplate = [
                '<span class="content">',
                    '<span class="name">{{name}}</span>',
                    '<span class="address">{{address}}</span>',
                '</span>',
            ].join('');
        const marker = {
                id: index,
                options: {
                    price: hotel.TotalPrice.toFixed(2),
                    name: hotel.Name,
                    address: hotel.Address,
                },
                latitude: hotel.Latitude,
                longitude: hotel.Longitude,
            };
        _.extend(marker.options, mapsFactory.markerOptionsDefaults);
        marker.options.labelClass = 'icon_address';
        marker.options.labelContent = _.template(labelTemplate)({
            name: hotel.Name,
            address: hotel.Address,
        });
        return marker;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/controllers/hotelViewMapCtrl.js